export const baseApi = process.env.REACT_APP_BASE_API
export const googleAuthKey = process.env.REACT_APP_GOOGLE_AUTH_KEY
export const referralTitle = process.env.REACT_APP_REFERRAL_TITLE
export const referralBodyText = process.env.REACT_APP_REFERRAL_BODY_TEXT
export const isDevelopment = true